function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 4c-3.3 0-6 2.7-6 6 0 1.2.4 2.4 1 3.4l-.9 2c-.1.2 0 .4.1.6.2.2.4.2.6.1l2-.9c1 .7 2.2 1 3.4 1 3.3 0 6-2.7 6-6S13.3 4 10 4zM7.3 8.3h5.5m-5.5 2h5.5m-5.5 2h5.5",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: ".5",
  stroke: "currentColor"
}));